import React from "react";
import { useTable, useRowSelect } from "react-table";
import styled from "styled-components";
import { LabelText } from "../../ui/Text";
import { EditDeleteFormatter } from "../../ui/TableFormatter";

interface TableProps {
  columns: any;
  data: any;
  setModal?: any;
}

export const LaggingMeasuresContent = ({ columns, data }: TableProps) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data }, useRowSelect, (hooks) => {
    hooks.visibleColumns.push((columns) => [...columns]);
  });

  return (
    <StyledTable>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <div style={{ display: "flex" }}>
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              </div>
            );
          })}
        </tbody>
      </table>
    </StyledTable>
  );
};

const StyledTable = styled.div`
  border-right: 1px solid #ebeeff;
  border-bottom: 1px solid #ebeeff;
  margin-bottom: 1em;
  table {
    width: 100%;
    border-spacing: 0;
    padding: 1em;
    thead {
      background-color: none;
      tr {
        background-color: #f5f6fb;
      }
    }
    th {
      font-size: 12px;
      color: #a0aebd;
      text-align: left;
    }
    tr {
      padding: 1em 1em;
      display: grid;
      grid-template-columns: 8fr 3fr 100px 3fr 3fr;
      color: black;
      font-size: 12px;
      background-color: #fff;
      width: 95%;
      align-items: center;
      margin: 0.3em 0;
      border-radius: 10px;
      &:hover {
        background-color: #ebeeff;
      }

      td {
        :first-child {
          /* background-color: red; */
        }
        :nth-child(2) {
          /* font-size: 14px;
          font-weight: bold; */
        }
      }
      ${LabelText} {
        font-size: 12px;
        margin-left: 1em;
        text-align: left;
      }
    }

    /* th, */
    /* td {
      margin: 0;
      :last-child {
        border-right: 0;
      }
    } */
  }
`;

// const Checkbox = styled.input`
//   height: 16px;
//   width: 16px;
//   -webkit-appearance: none;
//   -moz-appearance: none;
//   -o-appearance: none;
//   appearance: none;
//   border: 1px solid #e2e6f8;
//   border-radius: 3px;
//   outline: none;
//   transition-duration: 0.3s;
//   background-color: #fff;
//   cursor: pointer;
//   position: relative;
//   &:checked {
//     /* border: 1px solid #41b883; */
//     background-color: #01A8CE;
//   }

//   &:active {
//     /* border: 2px solid #; */
//   }
// `;
